'use strict'

angular
  .module('basalteApp')
  .constant('BAS_NETWORK', {
    EVT_NETWORK_STATE_CHANGED: 'evtEllieNetworkStateChanged'
  })
